import { AppText } from '@otomoro/components/shared/AppText'
import { AppTitle } from '@otomoro/components/shared/AppTitle'
import { SanityImage } from '@otomoro/components/shared/SanityImage'
import { PortableText, PortableTextComponents, SanityImageAssetDocument } from 'next-sanity'
import { PortableTextObject } from 'sanity'
import { styles, CircularityVariants } from './Circularity.css'
import { Tag } from '../../shared/Tag'

interface CircularityProps extends CircularityVariants {
	title: PortableTextObject
	characteristics: any[]
	illustration: SanityImageAssetDocument
}

export const Circularity: React.FC<CircularityProps> = ({
	title,
	characteristics,
	illustration,
}) => {
	const titleComponents = {
		block: {
			normal: ({ children }: any) => (
				<AppTitle
					as="h2"
					variant="h1"
					textTransform="uppercase"
					className="mt-1 lg:mt-2 col-span-3 row-span-1 max-w-[65rem]"
					color="white"
				>
					{children}
				</AppTitle>
			),
		},
		marks: {
			highlight: ({ children }: any) => <span className="text-mainPink">{children}</span>,
		},
	} as PortableTextComponents

	const { base, container, charGrid, charBox, image, figure, wrapper } = styles()

	return (
		<section className={base()}>
			<div className={wrapper()}>
				<Tag as="strong" theme='dark'>Schema</Tag>
				<div className={container()}>
					<PortableText value={title} components={titleComponents} />
					<SanityImage
						figureClass={figure()}
						className={image()}
						image={illustration.image}
						alt=""
						width={582}
						height={582}
						sizes={`100vw`}
					/>
					<div className={charGrid()}>
						{characteristics.map((characteristic, index) => (
							<div key={index} className={charBox()}>
								<AppTitle
									as="h3"
									variant='h3'
									color="mainPink"
									textTransform='uppercase'
								>
									{characteristic.name}
								</AppTitle>
								<AppText
									as="p"
									size="small"
									className="mt-1"
									color="white"
								>
									{characteristic.value}
								</AppText>
							</div>
						))}
					</div>
				</div>
			</div>
		</section>
	)
}
